import { api } from "services"

export async function getAdmins() {
  const { data } = await api.get("/admins?asList=1")
  
  return data
}